import { Play, ExternalLink } from "lucide-react";
import { useState } from "react";
import {homePoster1} from "../../assets/";
import {homePoster2} from "../../assets/";
import {homePoster3} from "../../assets/";
import {homePoster4} from "../../assets/";
import {homePoster5} from "../../assets/";
import {homePoster6} from "../../assets/";

interface Project {
  image?: string;
  title: string;
  youtubeLink?: string;
  youtube_link?: string;
  category: string;
}

interface ProjectsSectionProps {
  projects?: Project[];
}

const defaultProjects: Project[] = [
  {
    image: homePoster1,
    title: "The Punudai",
    youtubeLink: "https://youtu.be/pQysG_I0i0k",
    category: "Feature Film",
  },
  {
    image: homePoster2,
    title: "Punjabi Music Video",
    youtubeLink: "https://youtu.be/omsQAdouo-s",
    category: "Music Video",
  },
  {
    image: homePoster3,
    title: "Romaanie",
    youtubeLink: "https://youtu.be/EmWzgBzWhlA",
    category: "Romantic Drama",
  },
  {
    image: homePoster4,
    title: "Pasus",
    youtubeLink: "https://youtu.be/uMdpJieSTLk",
    category: "Action Thriller",
  },
  {
    image: homePoster5,
    title: "Family Drama",
    youtubeLink: "https://youtu.be/Lx1CI3RUNGc",
    category: "Comedy Drama",
  },
  {
    image: homePoster6,
    title: "Live Performance",
    youtubeLink: "https://youtu.be/2dEBvAzh_Lo",
    category: "Concert",
  },
];

export function ProjectsSection({ projects }: ProjectsSectionProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  
  const displayProjects = projects && projects.length > 0 ? projects.map(p => ({
      ...p,
      // Use API image URL or fallback
      image: p.image || homePoster1, 
      youtubeLink: p.youtube_link || p.youtubeLink
  })) : defaultProjects;

  return (
    <section id="projects" className="py-24 bg-secondary/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase mb-4">
            Our Portfolio
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-foreground mb-6">
            FEATURED <span className="text-gradient-gold">PROJECTS</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Explore our diverse portfolio of successful projects spanning films,
            music videos, and digital campaigns.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayProjects.map((project, index) => (
            <a
              key={index}
              href={project.youtubeLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-[3/4] rounded-xl overflow-hidden shadow-card hover-lift"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div
                className={`absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent transition-opacity duration-300 ${
                  hoveredIndex === index ? "opacity-100" : "opacity-60"
                }`}
              />

              {/* Play Button */}
              <div
                className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
                  hoveredIndex === index
                    ? "opacity-100 scale-100"
                    : "opacity-0 scale-90"
                }`}
              >
                <div className="w-16 h-16 rounded-full bg-gradient-gold flex items-center justify-center shadow-gold">
                  <Play size={28} className="text-primary-foreground ml-1" fill="currentColor" />
                </div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="text-primary text-sm font-medium tracking-wider uppercase">
                  {project.category}
                </span>
                <h3 className="font-display text-2xl text-foreground mt-2 group-hover:text-primary transition-colors flex items-center gap-2">
                  {project.title}
                  <ExternalLink size={18} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
              </div>
            </a>
          ))}
        </div>

        {/* <div className="text-center mt-12">
          <a
            href="https://www.google.com/search?q=baaj+media"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium tracking-wider transition-colors"
          >
            View All Projects
            <ExternalLink size={18} />
          </a>
        </div> */}
      </div>
    </section>
  );
}
